module.exports = __webpack_public_path__ + "228e4ee9247e1cceb504ad2281f14458.svg";